import * as React from "react";
import styles from "../styles/pages/informations.module.scss";
import MetaHeader from "../components/meta-header/meta-header";
import { useRouter } from "next/router";
// import { observable } from "mobx"
import { HeaderNewComponent } from "../new-components/header/Header";
import FooterNewComponent from "../new-components/footer/Footer";
import { useTranslation } from "next-i18next";
import KeysNewComponent from "../new-components/home/Keys/Keys";
import { trackPage } from "../api/analytics";
import nextI18NextConfig from "../next-i18next.config.js";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
const InformationsScreen = (props: { store: "fr" | "us" }) => {
  const router = useRouter();
  const { t, i18n } = useTranslation(["informations"]);

  function getDescription() {
    return "Plus d'informations";
  }

  function getId() {
    if (router && router.asPath) {
      return (router.asPath as string).replace("/", "").split("?")[0];
    }
    return "";
  }

  function getTitle() {
    return t(getId() + "_title");
  }

  React.useEffect(() => {
    trackPage("Informations_" + getId());
  }, []);

  function getText() {
    return t(getId(), { days: props.store === "us" ? 30 : 14 });
  }

  function getIcon() {
    if (getId() === "shipping") {
      return "DeliveryBig";
    }
    return "ReturnBig";
  }
  function getRedirect() {
    if (getId() === "shipping") {
      return null;
    }
    return (
      <>
        <p>Informations here are only available for the american market</p>
        <p>
          For the european, go{" "}
          <a href="https://choose.notion.site/201651951d7e48ceb142e3bb82a172ee#cc86530da1714c97aefdb6798dbe3fed">
            here
          </a>
        </p>
      </>
    );
  }
  return (
    <div className={styles.informations}>
      <MetaHeader description={getDescription()} title={getTitle()} />
      <HeaderNewComponent
        disableScroll={true}
        store={props.store}
        language={i18n.language}
      />
      <div className="container">
        <div className={`${styles.container} col-6 col-md-8 col-sm-12`}>
          <img
            src={`https://public.choose.app/website/new/images/${getIcon()}.png`}
            srcSet={`https://public.choose.app/website/new/images/${getIcon()}@2x.png 2x,https://public.choose.app/website/new/images/${getIcon()}@3x.png 3x`}
          />
          <h2>{getTitle()}</h2>
          {getRedirect()}
          <p dangerouslySetInnerHTML={{ __html: getText() }} />
          <hr />
          <h4>{t("btn_title")}</h4>
          <a href="mailto:contact@appchoose.io">
            <button>{t("btn")}</button>
          </a>
        </div>
        <hr className={styles.hr} />
      </div>

      <KeysNewComponent />
      <FooterNewComponent store={props.store} />
    </div>
  );
};

export const getServerSideProps = async (props) => {
  return {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "informations", "keys"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  };
};

export default InformationsScreen;
